import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

const TAG = ' --> Fetching:';

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const params = req.params.get('filters') || '';
  let pO = {};
  try {
    pO = JSON.parse(params);
  } catch (e) {

  }
  console.log(TAG, req.method, req.url, req.body ? req.body : '', pO ? pO : '');
  return next(req).pipe(
    tap(event => {
      if (event.type === HttpEventType.Response) {
        console.log(' <-- Response:', req.url, event.body);
      }
    }));
}
